export enum GroupType {
    Unspecified = 0,
    Default = 1
}